import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useWindowSize } from "@utils/hooks";
import EventTicketButton from "./eventTicketButton";
import { useIsShopsite } from "@context/DomainContext";
import { joinClassNames } from "@utils/helpers";

export default function StickyEventTicketButton({
  mainButtonRef,
  showEventDescription,
  onClick,
  href,
}: {
  mainButtonRef?: React.RefObject<HTMLDivElement | null>;
  showEventDescription?: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  href?: string;
}) {
  const [showFixedButton, setShowFixedButton] = useState(false);
  const windowSize = useWindowSize();
  const isShopsite = useIsShopsite();

  useEffect(() => {
    const handleScroll = () => {
      if (mainButtonRef?.current) {
        const { bottom } = mainButtonRef.current.getBoundingClientRect();
        const isLg = windowSize?.width && windowSize.width >= 1024;
        const footerOffset = isLg ? 328 : 264;
        const buttonOffset = isLg ? 100 : 132;
        const scrollPosition = window.scrollY + window.innerHeight;
        const pageHeight = document.documentElement.scrollHeight;

        setShowFixedButton(
          bottom < buttonOffset && scrollPosition < pageHeight - footerOffset
        );
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [mainButtonRef, windowSize]);

  return (
    <AnimatePresence>
      {showEventDescription && showFixedButton && (
        <motion.div
          key="fixed-event-button"
          id="fixed-event-button"
          className={joinClassNames(
            "w-full flex justify-center fixed bottom-2 sm:bottom-4 left-0",
            !isShopsite ? "md:hidden" : ""
          )}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ duration: 0.3 }}
        >
          <div className="w-full mx-auto max-w-4xl px-4 sm:px-10 lg:px-8 flex justify-center">
            <EventTicketButton
              showEventDescription={showEventDescription}
              onClick={onClick}
              href={href}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
